/**
 * @file Hompage Timeline
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Hompage Timeline component
 */
const vHpTimeline = () => {
	const hpTimeline = document.querySelector( '.v-hp-timeline' );
	if ( ! hpTimeline ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const rows = hpTimeline.querySelectorAll( '.v-hp-timeline__row' );

	ScrollTrigger.matchMedia( {
		'(min-width: 1331px)': () => {
			gsap.set( '.v-hp-timeline__arrow-stem--primary', {
				scaleY: 1,
				scaleX: 0,
			} );
			const animation = gsap.timeline( {
				defaults: {
					ease: 'sine.out',
				},
				scrollTrigger: {
					trigger: hpTimeline,
					start:   '75% bottom',
				},
			} )
				.to( '.v-hp-timeline__row:nth-child(1)', {
					opacity: 1,
					y:       0,
				} )
				.to( '.v-hp-timeline__arrow:nth-child(2) .v-hp-timeline__arrow-stem', {
					scaleX: 1,
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(2) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(3)', {
					opacity: 1,
					y:       0,
				}, '>-50%' )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-stem', {
					scaleX: 1,
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(5)', {
					opacity: 1,
					y:       0,
				}, '>-50%' )
				.to( '.v-hp-timeline__arrow:nth-child(6) .v-hp-timeline__arrow-stem', {
					scaleX: 1,
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(6) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(7)', {
					opacity: 1,
					y:       0,
				}, '>-50%' );

			return () => {
				animation.kill();
				animation
					.getChildren()
					.map( ( tween ) => [ ...tween.targets() ] )
					.flat()
					.forEach( ( target ) => target.removeAttribute( 'style' ) );
			};
		},
		'(min-width: 601px) and (max-width: 1330px)': () => {
			gsap.set( '.v-hp-timeline__arrow-stem--primary', {
				scaleY: 1,
				scaleX: 0,
			} );
			gsap.set( '.v-hp-timeline__arrow-stem--vertical', {
				scaleX: 1,
				scaleY: 0,
			} );
			const animation = gsap.timeline( {
				defaults: {
					ease: 'sine.out',
				},
				scrollTrigger: {
					trigger: hpTimeline,
					start:   '50% bottom',
				},
			} )
				.to( '.v-hp-timeline__row:nth-child(1)', {
					opacity: 1,
					y:       0,
				} )
				.to( '.v-hp-timeline__arrow:nth-child(2) .v-hp-timeline__arrow-stem--primary', {
					scaleX: 1,
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(2) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(3)', {
					opacity: 1,
					y:       0,
				}, '>-50%' )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-stem:nth-child(1)', {
					scaleY:   1,
					duration: .2,
					ease:     'linear',
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-stem--primary', {
					scaleX: 1,
					ease:   'linear',
				} )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-stem:nth-child(3)', {
					scaleY:   1,
					duration: .2,
				} )
				.to( '.v-hp-timeline__arrow:nth-child(4) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(5)', {
					opacity: 1,
					y:       0,
				}, '>-50%' )
				.to( '.v-hp-timeline__arrow:nth-child(6) .v-hp-timeline__arrow-stem--primary', {
					scaleX: 1,
				}, '>-25%' )
				.to( '.v-hp-timeline__arrow:nth-child(6) .v-hp-timeline__arrow-head', {
					opacity:  1,
					duration: .15,
				} )
				.to( '.v-hp-timeline__row:nth-child(7)', {
					opacity: 1,
					y:       0,
				}, '>-50%' );

			return () => {
				animation.kill();
				animation
					.getChildren()
					.map( ( tween ) => [ ...tween.targets() ] )
					.flat()
					.forEach( ( target ) => target.removeAttribute( 'style' ) );
			};
		},
		'(max-width: 600px)': () => {
			const animations = [];
			[ ...rows ].forEach( ( row ) => {
				const arrow = row.previousElementSibling;
				let stem;
				let head;
				if ( arrow ) {
					stem = arrow.querySelector( '.v-hp-timeline__arrow-stem--primary' );
					head = arrow.querySelector( '.v-hp-timeline__arrow-head' );

					gsap.set( stem, {
						scaleX: 1,
						scaleY: 0,
					} );
				}

				const animation = gsap.timeline( {
					defaults: {
						ease: 'sine.out',
					},
					scrollTrigger: {
						trigger: row,
						start:   '75% bottom',
					},
				} );

				if ( arrow ) {
					animation
						.to( stem, {
							scaleY: 1,
						} )
						.to( head, {
							opacity:  1,
							duration: .15,
						} );
				}

				animation.to( row, {
					opacity: 1,
					y:       0,
				} );

				animations.push( animation );
			} );

			return () => {
				animations.forEach( ( animation ) => {
					animation.kill();
					animation
						.getChildren()
						.map( ( tween ) => [ ...tween.targets() ] )
						.flat()
						.forEach( ( target ) => target.removeAttribute( 'style' ) );
				} );
			};
		},
	} );
};

export default vHpTimeline;
